module.exports = __webpack_public_path__ + "static/img/deliverer-location-pin.63ceabd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doorder/deliverer-location-pin.png
// module id = 2za9
// module chunks = 0